import axios from "axios";
import url from "./dynamicUrls";
import { useSelector, useDispatch } from 'react-redux'
import { ClientClassId, sectionId, SubjectId, teacherId } from '../redux/counterSlice'
import { fetchTeacherClasses } from "../api/apiRegister";

export const getAllUnitData = (issubjectId) => {
    var isteacherId = sessionStorage.getItem("teacher_id");
    const client_class_id = sessionStorage.getItem('client_class_id')
    const section_id = sessionStorage.getItem('section_id')

    console.log("issubjectId", issubjectId);
    console.log("isteacherId", isteacherId);
    if (issubjectId !== '' || issubjectId !== undefined || issubjectId !== null) {
        return new Promise((resolve, reject) => {
            axios.post(url.fetchUnitsandChaptersBasedonSubjects, {
                data: {
                    "subject_id": issubjectId,
                    "teacher_id": isteacherId,
                    "section_id": section_id,
                    "client_class_id": client_class_id
                }
            }, {
                headers: { Authorization: sessionStorage.getItem('user_jwt') }
            })
                .then((response) => {
                    console.log(response);
                    resolve(response.data);
                })
                .catch((error) => {
                    resolve({ Error: error });
                })
        });
    }

}

export const getAllTeacherClasses = (isteacherId) => {

    return new Promise(async (resolve, reject) => {
        const res = await fetchTeacherClasses({ data: { teacher_id: isteacherId  } });
        if (res) {console.log({res});
            resolve(res.data);}
            else{
                resolve({ Error: res });
            }
        // axios.post(url.fetchTeacherClasses, {
        //     data: {
        //         "teacher_id": isteacherId
        //     }
        // }, {
        //     headers: { Authorization: sessionStorage.getItem('user_jwt') }
        // })
        //     .then((response) => {
        //         console.log(response);
        //         resolve(response.data);
        //     })
        //     .catch((error) => {
        //         resolve({ Error: error });
        //     })
    });


}

export const getAllTeacherSections = (teacherId, ClassId) => {
    return new Promise((resolve, reject) => {
        axios.post(url.fetchTeacherSectionsBasedonClass, {
            data: {
                "teacher_id": teacherId,
                "client_class_id": ClassId
            }
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchClassBasedOnSchool = (school_id) => {
    console.log("school_id : ", school_id);

    return new Promise((resolve, reject) => {
        axios.post(url.fetchClassBasedOnSchool, {
            data: { school_id: school_id }
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchSchoolSection = (school_id) => {
    console.log("school_id : ", school_id);

    return new Promise((resolve, reject) => {
        axios.post(url.fetchSchoolSection, {
            data: { school_id: school_id }
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getAllTeacherSubjects = (teacherId, ClassId, sectionId) => {
    console.log("teacherId", teacherId);
    console.log("ClassId", ClassId);
    console.log("sectionId", sectionId);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchTeacherSubjectsBasedonSection, {
            data: {
                "teacher_id": teacherId,
                "client_class_id": ClassId,
                "section_id": sectionId
            }
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getAllPrePostTopics = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchTopicsBasedonChapter, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getAllDigicardS = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchDigicardsBasedonTopic, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}
export const rearrangeDigicard = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchDigiCardstoReorder, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const individualDigiCard = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchIndividualDigiCard, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fecthAllDigicardToUnlock = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchAllPreTopicDigicards, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchAllBluePrints = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchAllBluePrints, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchBlueprintById = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchBlueprintById, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchTopicsBasedonChapters = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchTopicsBasedonChapters, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchPostLearningTopicsBasedonChapters = (payload) =>{
 console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchPostLearningTopicsBasedonChapters, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchConceptsBasedonTopics = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.fetchConceptsBasedonTopics, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const unlockDigicard = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(url.digicardUnlock, {
            data: payload
        }, {
            headers: { Authorization: sessionStorage.getItem('user_jwt') }
        })
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchAvailableNumOfQuestions = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchAvailableNumOfQuestions,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}
export const fetchAvailableNumOfPostQuestions = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchAvailableNumOfQuestions,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getPreGrantedTeacherPermissions = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.getPreGrantedTeacherPermissions,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const checkDuplicateQuizName = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.checkDuplicateQuizName,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchDigicardExtension = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchDigicardExtension,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const addDigicardExtension = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.addDigicardExtension,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getPostGrantedTeacherPermissions = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.getPostGrantedTeacherPermissions,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const generatePrePostQuiz = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.generatePrePostQuiz,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const generateOTPForScanning = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.sendOTPForScanning,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);

            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const allPostTopicDigicardData = (payload) => {
    console.log("allPostTopicDigicardData", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchAllPostTopicDigicards,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fetchQueandChapters = (payload) => {
    console.log("fetchQuestionSourceandChapters", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchQuestionSourceandChapters,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const fecthAllQuestionData = (payload) => {
    console.log("fetchQuestionBasedOnBlueprint", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchQuestionBasedOnBlueprint,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const addTestQuestionPaper = (payload) => {
    console.log("addTestQuestionPaper", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.addTestQuestionPaper,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                resolve({ Error: error });
            })
    });
}

export const getAllQuestionPapers = (payload) => {
    console.log("fetchTestQuestionPapersBasedonStatus", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchTestQuestionPapersBasedonStatus,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const insertClassTest = (payload) => {
    console.log("insertClassTest", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.addClassTest,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const getClassQuizData = (payload) => {
    console.log("getClassQuizData", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchQuizBasedonStatus,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const getAllClassTest = (payload) => {
    console.log("getAllClassTest", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchClassTestsBasedonStatus,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}


export const nameValidation = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.validateQuestionPaperName,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const fetchClassTestById = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchClassTestById,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const fetchQuizTemplates = (payload) => {
    return new Promise((resolve, reject) => {
        axios.post(
            url.fetchQuizTemplates,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const fetchIndividualQuestion = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.viewTestQuestionPaper,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const fetchQuizQuestions = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.viewQuizQuestionPaper,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}


export const getAllStudentsBasedOnSection = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.getStudentsBasedOnSection,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}

export const getStudentResultData = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.getStudentResultData,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}


export const getStudentQuizResultData = (payload) => {
    console.log("payload", payload);
    return new Promise((resolve, reject) => {
        axios.post(
            url.getStudentQuizResultData,
            { data: payload },
            { headers: { Authorization: sessionStorage.getItem('user_jwt') } }
        )
            .then((response) => {
                console.log(response);
                resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                resolve({ Error: error });
            })
    });
}